import { useAuth } from '@/features/auth/hooks/use-auth';
import type { Permission } from '@/types';

/**
 * Qué puede hacer la persona con las reglas (decisión de Sebastián del 26-sep,
 * plan 4B-datos T1b): cinco permisos, configurables por rol y por rol
 * personalizado en Roles y permisos. Por omisión, el administrador de la
 * empresa los tiene todos; los demás roles, ninguno.
 *
 * La pantalla no ofrece lo que después daría 403: cada botón sale sólo con su
 * permiso. El backend decide igual (`permisos-reglas.middleware.ts`).
 */
export interface PermisosDeReglas {
  ver: boolean;
  crear: boolean;
  editar: boolean;
  encender: boolean;
  borrar: boolean;
  /** Alguno de crear, editar, encender o borrar. Sin ninguno, sólo lectura. */
  cambiaAlgo: boolean;
}

/** La cuenta, sin React: cualquiera de escritura implica ver (como el backend). */
export function permisosDeReglasDe(tiene: (p: Permission) => boolean): PermisosDeReglas {
  const crear = tiene('create_pricing_rules');
  const editar = tiene('edit_pricing_rules');
  const encender = tiene('toggle_pricing_rules');
  const borrar = tiene('delete_pricing_rules');
  const cambiaAlgo = crear || editar || encender || borrar;
  return {
    ver: tiene('view_pricing_rules') || cambiaAlgo,
    crear,
    editar,
    encender,
    borrar,
    cambiaAlgo,
  };
}

export function usePermisosDeReglas(): PermisosDeReglas {
  const { hasPermission } = useAuth();
  return permisosDeReglasDe(hasPermission);
}
